module.exports = __webpack_public_path__ + "static/media/x-close.83b1327f.svg";